class CollectionPagination extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.loadMoreButton = this.querySelector('[data-load-more-button]');
    if (!this.loadMoreButton) return;

    const productGridId = this.dataset.productGridId;
    this.productGrid = productGridId ? document.getElementById(productGridId) : null;
    if (!this.productGrid) return;

    this.pageSize = Number.parseInt(this.loadMoreButton.dataset.pageSize, 10) || 12;
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.loadMoreButton.addEventListener('click', this.handleLoadMore);
    this.dataset.ready = 'true';
    this.updateButton();
  }

  disconnectedCallback() {
    this.loadMoreButton?.removeEventListener('click', this.handleLoadMore);
    delete this.dataset.ready;
  }

  handleLoadMore() {
    const button = this.loadMoreButton;
    if (!button || !this.productGrid) return;

    const hiddenItems = [...this.productGrid.children].filter((item) => item.hasAttribute('data-pagination-hidden'));
    hiddenItems.slice(0, this.pageSize).forEach((item) => {
      item.hidden = false;
      item.removeAttribute('data-pagination-hidden');
    });

    this.updateButton();
  }

  updateButton() {
    if (!this.productGrid) return;

    const hasHiddenItems = [...this.productGrid.children].some((item) =>
      item.hasAttribute('data-pagination-hidden'),
    );
    if (!hasHiddenItems) this.remove();
  }
}

if (!customElements.get('collection-pagination')) {
  customElements.define('collection-pagination', CollectionPagination);
}
